import { render, staticRenderFns } from "./WareHousesPagination.vue?vue&type=template&id=39fd2da0&"
import script from "./WareHousesPagination.vue?vue&type=script&lang=js&"
export * from "./WareHousesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fd2da0')) {
      api.createRecord('39fd2da0', component.options)
    } else {
      api.reload('39fd2da0', component.options)
    }
    module.hot.accept("./WareHousesPagination.vue?vue&type=template&id=39fd2da0&", function () {
      api.rerender('39fd2da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/warehouses/views/components/WareHousesPagination.vue"
export default component.exports